import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { HierarchyNodeSelectionComponent } from './widgets/hierarchy-node-selection/hierarchy-node-selection.component';
import { HierarchySelectNodeComponent } from './widgets/hierarchy-select-node/hierarchy-select-node.component';
import { HierarchySelectComponent } from './widgets/hierarchy-select/hierarchy-select.component';
import { HierarchySelectionFilterComponent } from './widgets/hierarchy-selection-filter/hierarchy-selection-filter.component';
import { HierarchyStringTreeComponent } from './widgets/hierarchy-string-tree/hierarchy-string-tree.component';
import { HierarchyTreeWidgetComponent } from './widgets/hierarchy-tree-widget/hierarchy-tree-widget.component';

@NgModule({
  declarations: [
    HierarchySelectNodeComponent,
    HierarchySelectComponent,
    HierarchyStringTreeComponent,
    HierarchyNodeSelectionComponent,
    HierarchySelectionFilterComponent,
    HierarchyTreeWidgetComponent
  ],
  imports: [SharedModule],
  exports: [
    HierarchySelectNodeComponent,
    HierarchySelectComponent,
    HierarchyStringTreeComponent,
    HierarchyNodeSelectionComponent,
    HierarchySelectionFilterComponent,
    HierarchyTreeWidgetComponent
  ]
})
export class HierarchyWidgetsModule {}
